<div bsModal
     #cloneActivityModal="bs-modal"
     (onShown)="shown()"
     class="modal fade"
     tabindex="-1"
     role="dialog"
     [config]="{backdrop: 'static'}">
    <div class="modal-dialog modal-lg mat-calendar-style" style="max-width: 350px;">
        <div class="modal-content">
            <div class="modal-header no-border">
                {{ l('CloneActivitiesToOtherDays')}}
            </div>
            <div class="modal-body no-border" *ngIf="showCalendar">
                <mat-calendar #calendar
                              (selectedChange)="selectDate($event,calendar)"
                              [dateClass]="isSelected"></mat-calendar>
            </div>

            <div class="modal-footer no-border">
                <button [disabled]="saving"
                        type="button"
                        class="btn btn-default"
                        (click)="close()">
                    {{l("Cancel")}}
                </button>

                <button (click)="save()"
                        [disabled]="!daysSelected.length"
                        class="btn btn-primary blue"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')">
                    <i class="fa fa-save"></i>
                    <span>
                      {{l("Clone")}}
                    </span>
                </button>
            </div>

        </div>
    </div>

</div>
